module.exports = __webpack_public_path__ + "assets/img/starter_layout.89832126.jpg";